import { MenuItem, SubMenu } from "@szhsin/react-menu"
import { Fragment, memo, useCallback } from "react"
import { useModal } from "../../../../common/components/Modal"
import { setDisplayName } from "../../../../common/utils/setDisplayName"
import { useAppDispatch } from "../../../store/hooks"
import { HipsCustomUrlModal } from "../HipsCustomUrlModal"
import { hipsLayersSlice } from "../hipsLayersSlice"
import { TomoegozenSubmenu } from "../tomoegozen"
import { HipsSearch } from "./HipsSearch"
import { HipsDirectoryMenu } from "./directory"


export const HipsMenu = memo(() => {
  const dispatch = useAppDispatch()
  const { addLayer } = useModal()

  const addCustomUrl = useCallback(() => {
    const close = addLayer(
      <HipsCustomUrlModal
        onClose={() => close()}
        onSelect={baseUrl => {
          dispatch(hipsLayersSlice.actions.baseUrlChanged({ baseUrl }))
          close()
        }}
      />
    )
  }, [addLayer, dispatch])

  return (
    <Fragment>
      <HipsSearch />
      <SubMenu label="Recommended">
        <TomoegozenSubmenu />
      </SubMenu>
      <HipsDirectoryMenu />
      <MenuItem onClick={addCustomUrl}>Add URL...</MenuItem>
      <MenuItem onClick={() => dispatch(hipsLayersSlice.actions.baseUrlChanged({ baseUrl: undefined }))}>Clear</MenuItem>
      <MenuItem
        href="https://aladin.cds.unistra.fr/hips/list"
        target="_blank"
        rel="noreferrer"
      >
        HiPS list aggregator @ CDS
      </MenuItem>
    </Fragment>
  )
})
setDisplayName({ HipsMenu })
